import type { CSSProperties, HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';

interface C1GridProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  /** Minimum column width before the grid wraps. Defaults to 220px. */
  min?: number;
}

/** Responsive auto-fill grid used for cards and tiles. */
export function C1Grid({ children, min = 220, className, style, ...props }: C1GridProps) {
  return (
    <div
      className={cx('c1-grid', className)}
      style={{ ...style, '--c1-grid-min': `${min}px` } as CSSProperties}
      {...props}
    >
      {children}
    </div>
  );
}
